(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-cart-page-form]');
    if (!form) return;
    form.addEventListener('click', (event) => {
      const quantity = event.target.closest('.cart-page__quantity');
      if (!quantity) return;
      const input = quantity.querySelector('[data-page-quantity]');
      if (event.target.closest('[data-page-quantity-minus]')) input.value = Math.max(0, Number(input.value || 0) - 1);
      if (event.target.closest('[data-page-quantity-plus]')) input.value = Number(input.value || 0) + 1;
    });
    form.addEventListener('submit', (event) => {
      const button = event.submitter;
      if (!button) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const catalog = document.querySelector('[data-catalog]');
    if (!catalog) return;
    const filterForm = catalog.querySelector('[data-filter-form]');
    const sidebar = catalog.querySelector('[data-filter-sidebar]');
    const openButton = catalog.querySelector('[data-filter-open]');
    const closeFilters = () => {
      catalog.classList.remove('filters-open');
      openButton?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    openButton?.addEventListener('click', () => {
      catalog.classList.add('filters-open');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      sidebar.querySelector('button')?.focus();
    });
    catalog.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilters(); });
    catalog.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
      filterForm.querySelector('[data-filter-sort]').value = event.target.value;
      filterForm.submit();
    });
    filterForm?.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox' && window.matchMedia('(min-width: 990px)').matches) filterForm.submit();
    });
    catalog.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => {
      const list = button.dataset.view === 'list';
      catalog.querySelector('[data-product-grid]')?.classList.toggle('is-list', list);
      catalog.querySelectorAll('[data-view]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      try { localStorage.setItem('catalog-view', list ? 'list' : 'grid'); } catch (error) {}
    }));
    try {
      if (localStorage.getItem('catalog-view') === 'list') catalog.querySelector('[data-view="list"]')?.click();
    } catch (error) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const syncDisclosures = () => {
      document.querySelectorAll('.store-footer__disclosure').forEach((details) => {
        if (desktopQuery.matches) details.setAttribute('open', '');
        else details.removeAttribute('open');
      });
    };

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-localization-select]')) event.target.form.submit();
    });

    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!details.matches?.('.store-footer__disclosure') || desktopQuery.matches || !details.open) return;
      document.querySelectorAll('.store-footer__disclosure[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    }, true);

    syncDisclosures();
    desktopQuery.addEventListener('change', syncDisclosures);
    document.addEventListener('shopify:section:load', syncDisclosures);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-commerce-header]');
    if (!header) return;
    const menu = header.querySelector('[data-mobile-menu]');
    const toggle = header.querySelector('[data-mobile-menu-open]');
    const open = () => { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); toggle.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; menu.querySelector('[data-mobile-menu-close]:not(.commerce-header__mobile-overlay)')?.focus(); };
    const close = () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); toggle.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; toggle.focus(); };
    toggle.addEventListener('click', open);
    menu.querySelectorAll('[data-mobile-menu-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
      const form = root.querySelector('[data-product-form]');
      const variantInput = root.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-price]');
      const availability = root.querySelector('[data-availability]');
      const sku = root.querySelector('[data-sku]');
      const add = root.querySelector('[data-add]');
      const buyNow = root.querySelector('[data-buy-now]');
      const gallery = root.querySelector('[data-gallery]');
      const stage = root.querySelector('.showcase-gallery__stage');
      const thumbs = root.querySelector('[data-thumbs]');
      const thumbPrev = root.querySelector('[data-thumb-prev]');
      const thumbNext = root.querySelector('[data-thumb-next]');
      const moneyFormat = window.Shopify?.money_format;
      const formatMoney = (cents) => window.Shopify?.formatMoney && moneyFormat ? window.Shopify.formatMoney(cents, moneyFormat) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
      const isMobileGallery = () => window.matchMedia('(max-width: 989px)').matches;
      const syncRailHeight = () => {
        if (!gallery || !stage) return;
        if (isMobileGallery()) {
          gallery.style.removeProperty('--gallery-stage-height');
          return;
        }
        const height = Math.round(stage.getBoundingClientRect().height);
        if (height > 0) gallery.style.setProperty('--gallery-stage-height', `${height}px`);
      };
      const updateArrowState = () => {
        if (!thumbs || !thumbPrev || !thumbNext) return;
        const maxScroll = isMobileGallery()
          ? thumbs.scrollWidth - thumbs.clientWidth
          : thumbs.scrollHeight - thumbs.clientHeight;
        const current = isMobileGallery() ? thumbs.scrollLeft : thumbs.scrollTop;
        const canScroll = maxScroll > 1;
        thumbPrev.hidden = !canScroll;
        thumbNext.hidden = !canScroll;
        thumbPrev.disabled = !canScroll || current <= 1;
        thumbNext.disabled = !canScroll || current >= maxScroll - 1;
      };
      const scrollThumbs = (direction) => {
        if (!thumbs) return;
        const thumb = thumbs.querySelector('.showcase-gallery__thumb');
        const step = thumb ? (isMobileGallery() ? thumb.offsetWidth + 10 : thumb.offsetHeight + 10) : 100;
        thumbs.scrollBy({
          top: isMobileGallery() ? 0 : direction * step,
          left: isMobileGallery() ? direction * step : 0,
          behavior: 'smooth'
        });
      };
      const showMedia = (id) => {
        if (!id) return;
        root.querySelectorAll('[data-media]').forEach((item) => item.classList.toggle('is-active', item.dataset.media === String(id)));
        root.querySelectorAll('[data-media-target]').forEach((item) => {
          const active = item.dataset.mediaTarget === String(id);
          item.classList.toggle('is-active', active);
          if (active && thumbs) {
            const thumbStart = isMobileGallery() ? item.offsetLeft : item.offsetTop;
            const thumbSize = isMobileGallery() ? item.offsetWidth : item.offsetHeight;
            const viewStart = isMobileGallery() ? thumbs.scrollLeft : thumbs.scrollTop;
            const viewSize = isMobileGallery() ? thumbs.clientWidth : thumbs.clientHeight;
            if (thumbStart < viewStart) {
              thumbs.scrollTo({
                left: isMobileGallery() ? thumbStart : thumbs.scrollLeft,
                top: isMobileGallery() ? thumbs.scrollTop : thumbStart,
                behavior: 'smooth'
              });
            } else if (thumbStart + thumbSize > viewStart + viewSize) {
              const next = thumbStart + thumbSize - viewSize;
              thumbs.scrollTo({
                left: isMobileGallery() ? next : thumbs.scrollLeft,
                top: isMobileGallery() ? thumbs.scrollTop : next,
                behavior: 'smooth'
              });
            }
          }
        });
        requestAnimationFrame(() => {
          syncRailHeight();
          updateArrowState();
        });
      };
      root.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));
      thumbPrev?.addEventListener('click', (event) => {
        event.preventDefault();
        scrollThumbs(-1);
      });
      thumbNext?.addEventListener('click', (event) => {
        event.preventDefault();
        scrollThumbs(1);
      });
      thumbs?.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', () => {
        syncRailHeight();
        updateArrowState();
      });
      stage?.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => {
          syncRailHeight();
          updateArrowState();
        }, { once: true });
      });
      syncRailHeight();
      updateArrowState();
      form?.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        const optionGroup = event.target.closest('.showcase-product__option');
        const optionLabel = optionGroup?.querySelector('[data-option-label]');
        if (optionLabel) optionLabel.textContent = event.target.value;
        const options = [...form.querySelectorAll('.showcase-product__option')].map((group) => group.querySelector('input:checked')?.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        price.innerHTML = `<span>${formatMoney(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
        const stockText = variant.available ? (variant.inventory_management && variant.inventory_quantity > 0 ? `${variant.inventory_quantity} in stock` : 'In stock') : 'Sold out';
        if (availability) {
          availability.querySelector('.showcase-product__stock-dot').classList.toggle('is-unavailable', !variant.available);
          availability.querySelector('span:last-child').textContent = stockText;
        }
        if (sku) sku.textContent = variant.sku || '';
        add.disabled = !variant.available;
        if (buyNow) buyNow.disabled = !variant.available;
        add.querySelector('[data-add-text]').textContent = variant.available ? 'Add to cart' : 'Sold out';
        showMedia(variant.featured_media?.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      });
      const quantity = root.querySelector('[data-quantity]');
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => quantity.value = Math.max(1, Number(quantity.value || 1) - 1));
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => quantity.value = Number(quantity.value || 1) + 1);
      buyNow?.addEventListener('click', async () => {
        if (!variantInput.value || buyNow.disabled) return;
        buyNow.disabled = true;
        buyNow.textContent = buyNow.dataset.loadingLabel;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: Math.max(1, Number(quantity.value || 1)) }] })
          });
          if (!response.ok) throw new Error('Unable to add product');
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
        } catch (error) {
          buyNow.disabled = false;
          buyNow.textContent = buyNow.dataset.label;
          console.error(error);
        }
      });
      root.querySelector('[data-share]')?.addEventListener('click', async (event) => {
        if (navigator.share) await navigator.share({ title: document.title, url: window.location.href });
        else { await navigator.clipboard.writeText(window.location.href); event.currentTarget.querySelector('[data-share-text]').textContent = 'Link copied'; }
      });
      const tabsRoot = root.querySelector('[data-product-tabs]');
      const tabs = [...tabsRoot.querySelectorAll('[role="tab"]')];
      const activateTab = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          tabsRoot.querySelector(`[data-panel="${item.dataset.tab}"]`).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(index + direction + tabs.length) % tabs.length];
          activateTab(next);
          next.focus();
        });
      });
    };
    const mount = () => document.querySelectorAll('[data-product-root]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons({ strokeWidth: 1.5 });
    }

    document.querySelectorAll('[data-qty]').forEach((qty) => {
      const input = qty.querySelector('[data-quantity]');
      const minus = qty.querySelector('[data-qty-minus]');
      const plus = qty.querySelector('[data-qty-plus]');

      const set = (value) => {
        const min = parseInt(input.min) || 1;
        const max = input.max ? parseInt(input.max) : Infinity;
        const next = Math.min(Math.max(value, min), max);
        input.value = next;
      };

      minus?.addEventListener('click', () => set((parseInt(input.value) || 1) - 1));
      plus?.addEventListener('click', () => set((parseInt(input.value) || 1) + 1));
    });

    document.querySelectorAll('[data-share-copy]').forEach((button) => {
      const text = button.querySelector('[data-share-copy-text]');
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          if (text) text.textContent = 'Link copied';
          setTimeout(() => {
            if (text) text.textContent = 'Copy link';
          }, 2000);
        } catch (error) {
          window.prompt('Copy this link:', window.location.href);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media"]) return;
  try {
    
  class ProductMedia {
    constructor(gallery) {
      this.gallery = gallery;
      this.items = gallery.querySelectorAll('[data-media-item]');
      this.thumbs = gallery.querySelectorAll('[data-media-thumb]');
      this.main = gallery.querySelector('[data-media-main]');
      this.prevBtn = gallery.querySelector('[data-media-prev]');
      this.nextBtn = gallery.querySelector('[data-media-next]');

      this.activeIndex = [...this.items].findIndex((item) =>
        item.classList.contains('product-media__item--active')
      );
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.init();
    }

    init() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId));
      });

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));

      if (this.gallery.hasAttribute('data-media-zoom')) {
        this.items.forEach((item) => {
          if (!item.hasAttribute('data-zoomable')) return;
          const wrap = item.querySelector('[data-zoom-wrap]');
          if (!wrap) return;
          wrap.addEventListener('mousemove', (e) => {
            const rect = wrap.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            wrap.style.setProperty('--zoom-x', `${x}%`);
            wrap.style.setProperty('--zoom-y', `${y}%`);
          });
        });
      }
    }

    showMedia(mediaId) {
      this.items.forEach((item, index) => {
        const active = item.dataset.mediaId === mediaId;
        item.classList.toggle('product-media__item--active', active);
        if (active) this.activeIndex = index;
      });

      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle(
          'product-media__thumb--active',
          thumb.dataset.mediaId === mediaId
        );
      });
    }

    step(direction) {
      if (this.items.length < 2) return;
      const next = (this.activeIndex + direction + this.items.length) % this.items.length;
      this.showMedia(this.items[next].dataset.mediaId);
      this.scrollToActive();
    }

    scrollToActive() {
      const item = this.items[this.activeIndex];
      if (item && this.main) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    activateVariant(variantId) {
      let target = null;

      this.items.forEach((item) => {
        const ids = (item.dataset.variantIds || '').split(' ').filter(Boolean);
        if (ids.includes(String(variantId))) target = item;
      });

      if (!target) return;

      this.items.forEach((item) => item.classList.remove('product-media__item--active'));
      target.classList.add('product-media__item--active');
      this.activeIndex = [...this.items].indexOf(target);

      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle(
          'product-media__thumb--active',
          thumb.dataset.mediaId === target.dataset.mediaId
        );
      });

      this.scrollToActive();
    }
  }

  window.addEventListener('product:variant-change', (event) => {
    document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
      const instance = gallery.__productMedia;
      instance?.activateVariant(event.detail?.variantId);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons({ strokeWidth: 1.5 });
    }
    document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
      gallery.__productMedia = new ProductMedia(gallery);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.fetchRecommendations(this.dataset.url);
            this.disconnect();
          }
        });
      };

      this.observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 200px 0px',
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.disconnect();
    }

    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    async fetchRecommendations(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch recommendations');

        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          if (typeof lucide !== 'undefined') {
            lucide.createIcons({ strokeWidth: 1.5 });
          }
        }
      } catch (error) {
        console.error('Failed to load recommendations:', error);
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons({ strokeWidth: 1.5 });
    }

    document.querySelectorAll('[data-wishlist]').forEach((btn) => {
      const icon = btn.querySelector('[data-wishlist-icon]');
      btn.addEventListener('click', () => {
        btn.classList.toggle('is-active');
        icon?.setAttribute('fill', btn.classList.contains('is-active') ? 'currentColor' : 'none');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-topbar-localization]')) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();
})();
